import tephraProcessor from "./tephra_validation/processor";
import varDetector from "./variables_validation/detect";
import prettier from "prettier/standalone";
import parserPostcss from "prettier/parser-postcss";
import parserHTML from "prettier/parser-html";
import parserBabylon from "prettier/parser-babylon";

const postCSSPlugins = [parserPostcss];
const htmlPlugins = [parserHTML];
const babelPlugins = [parserBabylon];

export default function(lang, session, path = "") {
  const options = {
    printWidth: 200,
    tabWidth: 4
  };

  const prettyJS = () => {
    const content = session.getValue();
    if (content.length > 200000) return content;
    const ignoreFormatting = /\/\*\s*ixcanul-ignore-formatting\s*\*\//i.test(content);
    if (ignoreFormatting) return content;
    return prettier.format(content, {
      printWidth: 180,
      tabWidth: options.tabWidth,
      parser: "babel",
      plugins: babelPlugins
    });
  };

  const prettyHTML = (customValue = session.getValue()) => {
    return prettier.format(customValue, { ...options, parser: "html", plugins: htmlPlugins });
  };

  const prettyJSON = () => {
    return prettier.format(session.getValue(), { ...options, parser: "json", plugins: babelPlugins });
  };
  const prettyScss = () => {
    const content = session.getValue();
    const ignoreFormatting = /\/\*\s*ixcanul-ignore-formatting\s*\*\//i.test(content);
    if (ignoreFormatting) return content;
    return prettier.format(session.getValue(), {
      ...options,
      parser: "scss",
      plugins: postCSSPlugins
    });
  };

  const prettyCss = () => {
    const content = session.getValue();
    const ignoreFormatting = /\/\*\s*ixcanul-ignore-formatting\s*\*\//i.test(content);
    if (ignoreFormatting) return content;
    return prettier.format(session.getValue(), {
      ...options,
      parser: "scss",
      plugins: postCSSPlugins
    });
  };

  const joinStructuredLines = structuredLines =>
    structuredLines.map(line => line.prettyLine || line._line.content).join("\n");

  const selectionPos = session.selection.toJSON();
  const foldData = session.$cloneFoldData();
  try {
    let value, structuredLines, niceVariables;
    switch (lang) {
      case "html":
        session.doc.setValue(prettyHTML());
        break;
      case "liquid":
        value = session.getValue();
        structuredLines = tephraProcessor(session.getValue());
        value = joinStructuredLines(structuredLines);
        niceVariables = varDetector(value);
        value = joinStructuredLines(niceVariables);
        if (path.startsWith("tephra")) {
          value = addResetAssigns(value);
        }
        session.doc.setValue(value);
        break;
      case "js":
        session.doc.setValue(prettyJS());
        break;
      case "scss":
        session.doc.setValue(prettyScss());
        break;
      case "css":
        session.doc.setValue(prettyCss());
        break;
      case "json":
        session.doc.setValue(prettyJSON());
        if (!session.getValue().trim().length) {
          throw Error("This file cannot be empty");
        }
        break;
      default:
        break;
    }
    const Range = ace.require("ace/range").Range;
    foldData.forEach(fold => {
      session.addFold("...", new Range(fold.start.row, fold.start.column, fold.end.row, fold.end.column));
    });
    session.selection.fromJSON(selectionPos);
    return true;
  } catch (error) {
    console.error(error);
    return error.toString();
  }
}

function addResetAssigns(value = "") {
  if (!value.trim("").length) return value;

  let existing_reset = null;
  const lines = value.split("\n");
  const resetRegexp = new RegExp(/{%\s*reset_assigns\s*["']([a-z,A-Z0-9_-]*)["']\s*%}/, "g");
  const assigns = lines.reduce((acc, line, index) => {
    const liquidTagGroups = line.match(/({%(.*?)%})/gim);
    const reset = /\{%\s*reset_assigns/g.test(line);
    if (reset) {
      const resetMatch = resetRegexp.exec(line);
      if (resetMatch) {
        const stringMatch = resetMatch[0];
        const assigns = resetMatch[1];
        existing_reset = { index, assigns, stringMatch };
      }
    }

    if (liquidTagGroups && liquidTagGroups.length) {
      const assignsInGroups =
        liquidTagGroups.reduce((acc, tag) => {
          const match = /{%\s*(assign|variable|var|capture)\s*(\w*)/g.exec(tag);
          if (match) {
            return acc.concat(match[2]);
          }
        }, []) || [];
      if (assignsInGroups.length) {
        // if a match found after the reset, we shouldn't be using it
        existing_reset = null;
        return acc.concat(...assignsInGroups);
      }
    }
    return acc;
  }, []);
  // return if no assigns were found
  if (!assigns.length) return value;
  const assigns_str = [...new Set(assigns)].join(",");
  if (!existing_reset) {
    value += `\n\n{% reset_assigns "${assigns_str}" %}`;
  } else {
    if (assigns_str !== existing_reset.assigns) {
      const { index } = existing_reset;
      lines[index] = lines[index].replace(existing_reset.stringMatch, `{% reset_assigns "${assigns_str}" %}`);
      value = lines.join("\n");
    }
  }
  return value;
}
